export default __webpack_public_path__ + "static/media/coach.5ffcbd70.svg";